import { Fade, Typography } from '@material-ui/core'

import { getTranslate } from '../../localization'
import { CancelPolicy } from '../../types/cancelAndModifyPolicies'
import PolicyRowMobile from './PolicyRowMobile'
import PolicyRowMobileSkeleton from './PolicyRowMobile.skeleton'
import useStyles from './styles/PoliciesTable.styles'

interface PolicyTableMobileProps {
  data: CancelPolicy[]
  loadingForCancelPolicy: boolean
  providerCode: string
}

export const PolicyTableMobile: React.FC<PolicyTableMobileProps> = ({
  data,
  loadingForCancelPolicy,
  providerCode
}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.tableHeadMobile}>
        <div className={classes.tableHeadCellMobile}>
          <Typography variant="body1">{getTranslate('Name')}</Typography>
        </div>
        <div />
      </div>
      {loadingForCancelPolicy
        ? Array(5)
            .fill('')
            .map((item, index) => (
              <PolicyRowMobileSkeleton
                key={`accommodation-skeleton${item}${index.toString()}`}
              />
            ))
        : data.map((singlePolicy) => (
            <Fade in timeout={600} key={singlePolicy.basicDetails.id}>
              <div>
                <PolicyRowMobile
                  providerCode={providerCode}
                  data={singlePolicy}
                />
              </div>
            </Fade>
          ))}
    </div>
  )
}
